import { Settings } from '@streamr/tv-engine';
import { MediaPacket, } from '@streamr/tv-engine/~/proto';
export class MediaPacketFragmenter {
    static MAX_FRAGMENT_SIZE = Settings.maxFragmentSize;
    packetNumberCounter = 0;
    fragmentMediaPacket(packet) {
        const packetData = MediaPacket.toBinary(packet);
        const packetNumber = this.packetNumberCounter++;
        // If the packet is small enough, return it as a single fragment
        if (packetData.length <= MediaPacketFragmenter.MAX_FRAGMENT_SIZE) {
            return [
                {
                    packetNumber: BigInt(packetNumber),
                    fragmentNumber: 0,
                    numberOfFragments: 1,
                    data: packetData,
                    mediaStreamId: packet.mediaStreamId,
                },
            ];
        }
        // Calculate number of fragments needed
        const numberOfFragments = Math.ceil(packetData.length / MediaPacketFragmenter.MAX_FRAGMENT_SIZE);
        const fragments = [];
        // Split the packet data into fragments
        for (let i = 0; i < numberOfFragments; i++) {
            const start = i * MediaPacketFragmenter.MAX_FRAGMENT_SIZE;
            const end = Math.min(start + MediaPacketFragmenter.MAX_FRAGMENT_SIZE, packetData.length);
            const fragmentData = packetData.slice(start, end);
            fragments.push({
                packetNumber: BigInt(packetNumber),
                fragmentNumber: i,
                numberOfFragments,
                data: fragmentData,
                mediaStreamId: packet.mediaStreamId,
            });
        }
        return fragments;
    }
}
